import { ReactNode } from 'react'

type DetailItem = {
  label: string
  value: ReactNode
}

type DetailGridProps = {
  items: DetailItem[]
  columns?: 2 | 3 | 4
}

export function DetailGrid({ items, columns = 3 }: DetailGridProps) {
  const gridClass = {
    2: 'grid-cols-2',
    3: 'grid-cols-2 md:grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
  }[columns]

  return (
    <div className={`grid ${gridClass} gap-x-8 gap-y-4 py-4 border-b border-border/40`}>
      {items.map((item) => (
        <div key={item.label}>
          <dt className="text-[12px] font-medium text-muted-foreground uppercase tracking-wider mb-1">{item.label}</dt>
          <dd className="text-sm">{item.value}</dd>
        </div>
      ))}
    </div>
  )
}
